module.exports = __webpack_public_path__ + "img/adulto45.c4b6dbf6.jpg";